import * as React from "react"
import type { SVGProps } from "react"
const SvgBolt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m10.55 18.63 5.18-6.2h-4l.72-5.68-4.62 6.68h3.47zM9 15.43H5.9q-.6 0-.89-.54a.9.9 0 0 1 .07-1.04L12.55 3.1q.25-.35.65-.48.4-.15.83 0t.62.53c.2.38.18.52.15.8l-.8 6.48h3.88q.64 0 .9.57.27.58-.16 1.08l-8.22 9.85a1.3 1.3 0 0 1-.67.42 1 1 0 0 1-.78-.07 1.3 1.3 0 0 1-.59-.54 1.2 1.2 0 0 1-.16-.79z" />
  </svg>
)
export default SvgBolt
